import { BF2GetCheckCallouts } from "../graphics/outskirts/BF2GetCheckCallouts";
import { BF2GetExclamationMarkCallouts } from "../graphics/outskirts/BF2GetExclamationMarkCallouts";
import { BF2GetExclamationMarkEventCallouts } from "../graphics/outskirts/BF2GetExclamationMarkEventCallouts";
import { BF2GetWaterCallouts } from "../graphics/outskirts/BF2GetWaterCallouts";
import { GetDiscountCallouts } from "../graphics/outskirts/GetDiscountCallouts";
import { IdOutskirtBuildings } from "./IdOutskirtBuildings";
export var mapOutskirtsCallout = new Map([
    [IdOutskirtBuildings.Cafe, function () { return undefined; }],
    [IdOutskirtBuildings.Doghouse, BF2GetExclamationMarkEventCallouts],
    [IdOutskirtBuildings.TournamentTent, BF2GetExclamationMarkCallouts],
    [IdOutskirtBuildings.Watertower, BF2GetWaterCallouts],
    [IdOutskirtBuildings.Nursery, function () { return undefined; }],
    [IdOutskirtBuildings.ThemedEvent, BF2GetExclamationMarkEventCallouts],
    [IdOutskirtBuildings.Market, BF2GetCheckCallouts],
    [IdOutskirtBuildings.ExternalBarn, GetDiscountCallouts],
    [IdOutskirtBuildings.Library, function () { return undefined; }],
    [IdOutskirtBuildings.Pier, function () { return undefined; }],
    [IdOutskirtBuildings.Harbor, function () { return undefined; }],
]);



//////////////////
// WEBPACK FOOTER
// ./src/constants/mapOutskirtsCallout.tsx
// module id = 2133
// module chunks = 3